export default __webpack_public_path__ + "static/img2-cd89923fe31222b4b166a213066ab995.png";